import {IvStoreService} from "./IvStoreService";
import {UserStripeService} from "../../../stripe/service/UserStripeService";
import {BundleProduct, StoreProductState, StoreProductStates} from "../../common/models/StoreProductState";
import {StoreViewStore} from "../../common/services/StoreViewStore";
import {IvStoreProduct} from "../models/IvStoreProduct";

export class IvStoreViewStore extends StoreViewStore<IvStoreProduct> {

    private constructor(ivStoreService: IvStoreService, userStripeService: UserStripeService) {
        super(ivStoreService, userStripeService);
    }

    public toggleProState() {
        this.toggleProductState(IvStoreProduct.PRO);
    }

    public toggleBacktestingState() {
        this.toggleProductState(IvStoreProduct.BACKTESTING);
    }

    public toggleAlertingState() {
        this.toggleProductState(IvStoreProduct.TRADING_SYSTEMS);
    }

    public toggleBundleState() {
        this.productState$
            .take(1)
            .map((state) => state.BUNDLE)
            .filter((bundle) => !bundle.locked)
            .subscribe((bundle) => {
                if (bundle.selected) {
                    this.resetState();
                } else {
                    const productStates = BundleProduct();
                    const bundleState: StoreProductState = {
                        selected: true,
                        locked: false,
                        inBundle: false,
                        hasTrialAvailable: false
                    };
                    const newState: StoreProductStates<IvStoreProduct> = {
                        PRO: productStates,
                        BACKTESTING: productStates,
                        TRADING_SYSTEMS: productStates,
                        BUNDLE: bundleState
                    };
                    this.updateState(newState);
                }
            });
    }

    public static initialize(storeService: IvStoreService, userStripeService: UserStripeService): IvStoreViewStore {
        return new IvStoreViewStore(storeService, userStripeService);
    }
}
